import conf from 'conf/conf';
import { formatPrice } from 'utils/helpers/functions/pricesFunctions';
import {
    getBaseCurrencyCode,
    getCurrencyCode,
} from 'utils/helpers/currency/currencyHelpers';

export const COLLAPSED_STORAGE_KEY = 'sidebarTariffCollapsed';

export const isUahCurrency = (): boolean => (
    String(conf.currencyCode || conf.currentCode || '').toUpperCase() === 'UAH'
);

export const getUsdRate = (settingsRate?: number | string | null): number => {
    const rate = Number(conf.usdRate) || Number(settingsRate) || 0;
    return rate > 0 ? rate : 1;
};

export const formatTariffPrice = (
    priceUsd: number,
    isUsd: boolean,
    usdRate: number,
    locale: string,
): string => {
    const value = isUsd ? priceUsd : priceUsd * usdRate;
    const currency = isUsd ? getBaseCurrencyCode() : getCurrencyCode();
    return formatPrice(value, currency, locale, 0, 0);
};

export const formatInvoiceAmount = (
    priceUsd: number,
    usdRate: number,
    locale: string,
): string => {
    if (isUahCurrency() || conf.currencyOnce) {
        return formatPrice(priceUsd * usdRate, getCurrencyCode(), locale, 0, 0);
    }
    return formatPrice(priceUsd, getBaseCurrencyCode(), locale, 0, 0);
};

export const readCollapsedState = (): boolean => {
    try {
        return localStorage.getItem(COLLAPSED_STORAGE_KEY) === '1';
    } catch {
        return false;
    }
};

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export const formatCompactFileSize = (bytes: number): string => {
    if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';

    let unitIndex = 0;
    let value = bytes;
    while (value >= 1024 && unitIndex < FILE_SIZE_UNITS.length - 1) {
        value /= 1024;
        unitIndex += 1;
    }

    if (unitIndex === 0) return `${Math.round(value)} B`;

    const compact = parseFloat(value.toFixed(value >= 10 ? 1 : 2)).toString();
    return `${compact} ${FILE_SIZE_UNITS[unitIndex]}`;
};

export const getUsagePercent = (used: number, limit: number): number => {
    if (!limit || limit <= 0) return 0;
    return Math.min(Math.round((used / limit) * 100), 100);
};

export const getFillClass = (percent: number): string => {
    if (percent >= 90) return 'sidebar-tariff__fill--danger';
    if (percent >= 70) return 'sidebar-tariff__fill--warning';
    return 'sidebar-tariff__fill--success';
};
